import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import EventPostScoreFormWrapper from '../../../pages/PostScorePage/EventPostScoreFormWrapper';
import { EventTypes, isEventType } from '../../../utils/events';
import { resolvePostScorePopupDicts } from '../../../utils/postScore';

import postScoreStyles from '../../../pages/PostScorePage/postScore.scss';
import styles from './eventPostScorePopup.scss';

const EventPostScorePopup = ({
    onCloseClick,
    event,
    drawsDict,
    selectedDrawId,
    draw,
    players,
    playersDict,
    playersDictByMemberId,
    teams,
    teamsDict,
    roundIndex,
    activeRound,
    matchIndex,
    matches,
    postScoreAction,
}) => {
    const isDualMatch = isEventType(event, EventTypes.DUAL_MATCH);
    const closeWithoutSaving = () => {
        onCloseClick();
    };
    const windowInnerHeight = window?.innerHeight > 650 ? 650 : window.innerHeight;
    const minHeight = window ? windowInnerHeight : '100%';
    const [expanded, setExpanded] = useState(false);

    const {
        playersDictByMemberId: derivedPlayersDict,
        teamsDict: derivedTeamsDict,
        players: derivedPlayers,
    } = useMemo(
        () => resolvePostScorePopupDicts({ playersDictByMemberId, teamsDict, players, matches }),
        [playersDictByMemberId, teamsDict, players, matches],
    );

    return (
        <Popup
            onCloseClick={closeWithoutSaving}
            className="popup-md"
            popUpContentWrapperClassName={`overflow-unset`}
            config={{
                noPadding: false,
                showCloseIcon: true,
                scrollable: true,
                style: {
                    maxHeight: '85vh',
                    minHeight,
                    height: expanded ? 'min(85vh, 750px)' : 'min(65vh, 550px)',
                },
            }}
        >
            <div className={`${styles.container}`}>
                <div>
                    <div className={styles.title} data-testid="modal.post-score.title">
                        Post a Score
                    </div>
                    <div className={`${postScoreStyles.section}`}>
                        <EventPostScoreFormWrapper
                            event={event}
                            drawsDict={drawsDict}
                            selectedDrawId={selectedDrawId}
                            draw={draw}
                            players={derivedPlayers}
                            playersDict={playersDict}
                            playersDictByMemberId={derivedPlayersDict}
                            teams={teams}
                            teamsDict={derivedTeamsDict}
                            roundIndex={roundIndex}
                            activeRound={activeRound}
                            defaultMatchIndex={matchIndex}
                            closeWithoutSaving={closeWithoutSaving}
                            isDualMatch={isDualMatch}
                            matches={matches}
                            drawIndex={null}
                            childDrawIndex={null}
                            isInPopup={true}
                            postEventScore={postScoreAction}
                            showExitButton={true}
                            isExpanded={setExpanded}
                        />
                    </div>
                </div>
            </div>
        </Popup>
    );
};

EventPostScorePopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    event: PropTypes.shape({}).isRequired,
    drawsDict: PropTypes.shape({}),
    selectedDrawId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    draw: PropTypes.shape({}),
    players: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.objectOf(PropTypes.shape({}))]),
    playersDict: PropTypes.shape({}),
    playersDictByMemberId: PropTypes.shape({}),
    teams: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.objectOf(PropTypes.shape({}))]),
    teamsDict: PropTypes.shape({}),
    roundIndex: PropTypes.number,
    activeRound: PropTypes.number,
    matchIndex: PropTypes.number,
    matches: PropTypes.arrayOf(PropTypes.shape({})),
    postScoreAction: PropTypes.func,
};

EventPostScorePopup.defaultProps = {
    drawsDict: null,
    selectedDrawId: null,
    draw: null,
    players: null,
    playersDict: null,
    playersDictByMemberId: null,
    teams: null,
    teamsDict: null,
    roundIndex: null,
    activeRound: null,
    matchIndex: null,
    matches: null,
    postScoreAction: null,
};

export default EventPostScorePopup;
